import { toast } from "sonner"

const LINK_FAILED = "Couldn't open the file. Try again."

/**
 * Open a stored file with a link fetched NOW: download links last five
 * minutes, so one kept from when the file was made can have expired. The tab
 * is opened before the fetch, while the click still counts as the user's,
 * so the browser doesn't block it as a pop-up.
 */
export async function openWithFreshLink(fetchUrl: () => Promise<string | null>): Promise<void> {
  const tab = window.open("", "_blank")
  let url: string | null = null
  try {
    url = await fetchUrl()
  } catch {
    url = null
  }
  if (!url) {
    tab?.close()
    toast.error(LINK_FAILED)
    return
  }
  if (tab) {
    tab.opener = null
    tab.location.href = url
  } else {
    window.open(url, "_blank", "noopener,noreferrer")
  }
}
